import { companyEmailBlacklist } from './company_email_blacklist';
import I18n from '~/utils/translations';

// From https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#Basic_validation
export const validEmailPattern =
  "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$";
export const validNumberPattern = '^[0-9]+(.[0-9]{2})?$';

export function validEmail(email) {
  if (!email) {
    return false;
  }
  return email.match(new RegExp(validEmailPattern));
}

export function validPrice(price) {
  if (!price) {
    return false;
  }
  return price.match(new RegExp(validNumberPattern));
}

export const companyEmailValidation = (email) => {
  if (!email || !validEmail(email)) {
    return [I18n.t('pages.agents_form.errors.agent_email')];
  }
  const [prefix, domain] = email.toLowerCase().split('@');
  if (!isCompanyPrefix(prefix)) {
    return [I18n.t('pages.agents_form.errors.agent_email_prefix')];
  }
  if (!isCompanyDomain(domain)) {
    return [I18n.t('pages.agents_form.errors.agent_email_domain')];
  }
  return [];
};

function isCompanyPrefix(value) {
  return !companyEmailBlacklist.prefixes.has(value);
}

function isCompanyDomain(value) {
  const domainParts = value.split('.');
  const provider = domainParts[0];
  return !companyEmailBlacklist.domains.has(provider);
}
